module.exports = __webpack_public_path__ + "img/github.e106fb49.png";